import React from 'react'
import { AzureAD, AuthenticationState } from 'react-aad-msal'
import { Button, Alert } from 'reactstrap'
import { authProvider } from '../../services/authProvider'
import { Navbar, NavLink, NavbarBrand, Nav, NavItem, Spinner } from 'reactstrap'
import { motion } from 'framer-motion'
import styled from 'styled-components'
import store from '../../store/configureStore'
import logo from '../Shared/Logo.png'
import PageHeading from '../Shared/LayoutComponents/PageHeading'

const HeroSection = styled.div`
  max-width: 60em;
  padding: 50px;
  margin: 100px 50px;
  text-align: center;
  background: rgb(159, 186, 221);
  border-radius: 50px;
`

const icon = {
  hidden: {
    opacity: 0,
    pathLength: 0,
    fill: '#fff',
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    fill: '#0056b8',
  },
}

const Login = (props) => {
  return (
    <AzureAD provider={authProvider} reduxStore={store}>
      {({ login, authenticationState, error }) => {
        const isInProgress = authenticationState === AuthenticationState.InProgress
        return (
          <React.Fragment>
            <Navbar color="primary" dark expand="md" className="fixed-top" style={{ transition: '0.5s ease' }}>
              <NavbarBrand>
                <img style={{ marginRight: '1rem' }} height={30} src={logo} alt="OSIT" />
                User Manager
              </NavbarBrand>
              <Nav className="rightNav ml-auto" navbar>
                <NavItem>
                  <NavLink style={{ cursor: 'pointer' }} color="white" onClick={login} disabled={isInProgress}>
                    Log In
                  </NavLink>
                </NavItem>
              </Nav>
            </Navbar>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <HeroSection>
                <PageHeading center={true} large={true} main={true}>
                  OSIT User Manager
                </PageHeading>
                <div
                  style={{
                    padding: '20px 50px 50px 50px',
                    stroke: '#0056b8',
                    strokeWidth: '4',
                    strokeLinejoin: 'round',
                    strokeLinecap: 'round',
                  }}
                  className="item"
                >
                  <motion.svg xmlns="http://www.w3.org/2000/svg" width="180px" height="180px" viewBox="0 0 300 300">
                    <g>
                      <motion.path
                        variants={icon}
                        initial="hidden"
                        animate="visible"
                        transition={{
                          default: { duration: 1.5, ease: 'easeInOut' },
                          fill: { duration: 1.5, ease: [1, 0, 0.8, 1] },
                        }}
                        d="M39.169 65.873c3.286 2.507 7.98 1.876 10.488-1.408 22.071-28.917 55.546-45.5 91.843-45.5s69.772 16.584 91.843 45.5c1.473 1.929 3.7 2.942 5.954 2.942 1.582 0 3.179-.5 4.534-1.534 3.284-2.508 3.914-7.203 1.408-10.488C220.312 22.729 182.501 4 141.5 4S62.688 22.729 37.762 55.385C35.255 58.67 35.885 63.365 39.169 65.873z"
                      ></motion.path>{' '}
                      <motion.path
                        variants={icon}
                        initial="hidden"
                        animate="visible"
                        transition={{
                          default: { duration: 1.5, ease: 'easeInOut' },
                          fill: { duration: 1.5, ease: [1, 0, 0.8, 1] },
                        }}
                        d="m228.037,101.786c0,12.885 10.484,23.369 23.369,23.369s23.369-10.484 23.369-23.369-10.484-23.369-23.369-23.369-23.369,10.483-23.369,23.369z"
                      ></motion.path>{' '}
                      <motion.path
                        variants={icon}
                        initial="hidden"
                        animate="visible"
                        transition={{
                          default: { duration: 1.5, ease: 'easeInOut' },
                          fill: { duration: 1.5, ease: [1, 0, 0.8, 1] },
                        }}
                        d="m275.322,132.91c-0.054-0.018-5.942-1.825-5.942-1.825-2.132-0.651-4.448-0.25-6.233,1.086l-11.741,8.791-11.741-8.791c-1.786-1.337-4.103-1.738-6.233-1.086 0,0-5.888,1.807-5.942,1.825-9.474,3.159-15.839,11.99-15.839,21.976v35.329c0,1.363 0.398,2.696 1.148,3.834l11.848,18.031v47.352c0,3.857 3.126,6.983 6.983,6.983h39.553c3.857,0 6.983-3.126 6.983-6.983v-47.352l11.848-18.031c0.749-1.139 1.148-2.472 1.148-3.834v-35.329c-5.68434e-14-9.986-6.366-18.817-15.84-21.976z"
                      ></motion.path>{' '}
                      <motion.path
                        variants={icon}
                        initial="hidden"
                        animate="visible"
                        transition={{
                          default: { duration: 1.5, ease: 'easeInOut' },
                          fill: { duration: 1.5, ease: [1, 0, 0.8, 1] },
                        }}
                        d="m45.594,125.155c12.885,0 23.369-10.484 23.369-23.369s-10.484-23.369-23.369-23.369-23.37,10.483-23.37,23.369 10.484,23.369 23.37,23.369z"
                      ></motion.path>{' '}
                      <motion.path
                        variants={icon}
                        initial="hidden"
                        animate="visible"
                        transition={{
                          default: { duration: 1.5, ease: 'easeInOut' },
                          fill: { duration: 1.5, ease: [1, 0, 0.8, 1] },
                        }}
                        d="m69.51,132.91c-0.054-0.018-5.942-1.825-5.942-1.825-2.133-0.651-4.447-0.25-6.233,1.086l-11.741,8.791-11.741-8.791c-1.785-1.337-4.103-1.738-6.233-1.086 0,0-5.888,1.807-5.942,1.825-9.474,3.159-15.839,11.99-15.839,21.976v35.329c0,1.363 0.398,2.696 1.148,3.834l11.848,18.031v47.352c0,3.857 3.126,6.983 6.983,6.983h39.552c3.857,0 6.983-3.126 6.983-6.983v-47.352l11.848-18.031c0.749-1.139 1.148-2.472 1.148-3.834v-35.329c0-9.986-6.366-18.817-15.839-21.976z"
                      ></motion.path>{' '}
                      <motion.path
                        variants={icon}
                        initial="hidden"
                        animate="visible"
                        transition={{
                          default: { duration: 1.5, ease: 'easeInOut' },
                          fill: { duration: 1.5, ease: [1, 0, 0.8, 1] },
                        }}
                        d="m178.642,68.851c0-16.62-13.522-30.142-30.142-30.142s-30.142,13.522-30.142,30.142c0,16.621 13.522,30.142 30.142,30.142s30.142-13.521 30.142-30.142z"
                      ></motion.path>{' '}
                      <motion.path
                        variants={icon}
                        initial="hidden"
                        animate="visible"
                        transition={{
                          default: { duration: 1.5, ease: 'easeInOut' },
                          fill: { duration: 1.5, ease: [1, 0, 0.8, 1] },
                        }}
                        d="m181.607,113.601l-.05-.016-8.603-2.64c-1.357-0.417-2.807,0.301-3.295,1.64l-18.09,49.635c-1.044,2.863-5.093,2.863-6.137,0l-18.09-49.635c-0.394-1.081-1.414-1.759-2.508-1.759-0.259,0-9.38,2.755-9.38,2.755-10.99,3.662-18.332,13.85-18.332,25.37v52.506c0,0.521 0.153,1.031 0.439,1.467l18.876,28.724v72.68c0,1.476 1.196,2.672 2.672,2.672h58.783c1.476,0 2.672-1.196 2.672-2.672v-72.68l18.876-28.724c0.286-0.436 0.439-0.946 0.439-1.467v-52.644c-0.001-11.47-7.372-21.641-18.272-25.212z"
                      ></motion.path>{' '}
                      <motion.path
                        variants={icon}
                        initial="hidden"
                        animate="visible"
                        transition={{
                          default: { duration: 1.5, ease: 'easeInOut' },
                          fill: { duration: 1.5, ease: [1, 0, 0.8, 1] },
                        }}
                        d="m155.568,112.556c-0.747-0.814-1.84-1.224-2.946-1.224h-8.245c-1.105,0-2.198,0.41-2.946,1.224-1.157,1.261-1.325,3.082-0.504,4.505l4.407,6.644-2.063,17.405 4.063,10.808c0.396,1.087 1.933,1.087 2.33,0l4.063-10.808-2.063-17.405 4.407-6.644c0.822-1.423 0.654-3.244-0.503-4.505z"
                      ></motion.path>{' '}
                      <motion.path
                        variants={icon}
                        initial="hidden"
                        animate="visible"
                        transition={{
                          default: { duration: 1.5, ease: 'easeInOut' },
                          fill: { duration: 1.5, ease: [1, 0, 0.8, 1] },
                        }}
                        d="m155.568,112.556c-0.747-0.814-1.84-1.224-2.946-1.224h-8.245c-1.105,0-2.198,0.41-2.946,1.224-1.157,1.261-1.325,3.082-0.504,4.505l4.407,6.644-2.063,17.405 4.063,10.808c0.396,1.087 1.933,1.087 2.33,0l4.063-10.808-2.063-17.405 4.407-6.644c0.822-1.423 0.654-3.244-0.503-4.505z"
                      ></motion.path>{' '}
                    </g>
                  </motion.svg>
                </div>
                {isInProgress ? (
                  <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                ) : (
                  <motion.div
                    animate={{ scale: [2, 1] }}
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.8 }}
                    transition={{ duration: 0.75 }}
                  >
                    <Button style={{ minWidth: '160px' }} size="lg" color="primary" onClick={login}>
                      LOG IN
                    </Button>
                  </motion.div>
                )}
                {error && (
                  <Alert color="danger" style={{ marginTop: '50px' }}>
                    Sorry, something went wrong logging you in.
                    <br />
                    Make sure you are using an OSIT Account and Try again.
                  </Alert>
                )}
              </HeroSection>
            </div>
          </React.Fragment>
        )
      }}
    </AzureAD>
  )
}

export default Login
